import "./TopPageFilters.scss";

import React from "react";

import { TableSearch } from "../../../../components/TableSearch";
import { RequestsDateFilter } from "../Filters/RequestsDateFilter";

const Search = () => {
  return (
    <div className="requests-top align-items-start">
      <div className="requests-top__search">
        <TableSearch
          label={
            <>
              <strong>Search</strong> through all requests
            </>
          }
          placeholder="Type to filter..."
        />
      </div>
      <div className="requests-top__date-filter">
        <RequestsDateFilter />
      </div>
    </div>
  );
};

export { Search };
